import { render, staticRenderFns } from "./viewdetail.vue?vue&type=template&id=56759e79&scoped=true&"
import script from "./viewdetail.vue?vue&type=script&lang=js&"
export * from "./viewdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56759e79",
  null
  
)

export default component.exports